import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { flow } from "lodash";
import Loader from "../../components/LoaderOverlay";

const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  height: 100vh;
`;

const Shell = styled.div`
  position: absolute;
  box-sizing: border-box;
  overflow: auto;
  width: 500px;
  padding: 50px;
  border-radius: 6px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    width: 100px;
    margin-bottom: 40px;
  }

  input {
    padding: 15px;
    border-radius: 3px;
    width: 100%;
    margin-bottom: 15px;
    font-size: 12px;
    color: #4c4c4c;
    outline: none;
    border: 1px solid #d4d9e2;
    box-sizing: border-box;
  }

  h2 {
    font-size: 20px;
    color: #434c5f;
    font-weight: 400;
    letter-spacing: 0.7px;
    line-height: 14px;
    margin-bottom: 40px;
    align: left;
  }

  p {
    color: #596377;
    font-size: 14px;
    line-height: 20px;
    font-weight: 100;
    margin-bottom: 40px;
  }

  a {
    display: block;
    font-size: 12px;
    margin-bottom: 20px;

    &.reject {
      font-family: Roboto-Light;
      color: #c0c0c0;
      letter-spacing: 0.78px;
    }
  }
`;

const Submit = styled.button`
  background: #ffffff;
  border: 1px solid #34a8f0;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.21);
  border-radius: 3px;
  text-transform: uppercase;
  color: #34a8f0;
  padding: 15px 0;
  text-decoration: none;
  width: 100%;
  margin-top: 15px;
  font-size: 12px;
  cursor: pointer;
`;

const ErrorMessage = styled.caption`
  color: red;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 15px;
  font-weight: 500;
  display: block;
`;

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderVisible: false,
      error: ""
    };
  }

  loginUser = () => {
    this.setState({ loaderVisible: true });
    this.setState({ error: "" });

    this.props
      .logIn(this.state.email, this.state.password)
      .then(token => {
        localStorage.setItem("token", token.data.signInUser);
        if (token) {
          this.props.goToInterview();
        }
      })
      .catch(error => {
        // debugger
        this.setState({ error: error.message });
        this.setState({ loaderVisible: false });
        console.log(error);
      });
  };

  inputToState = e => {
    if (e.target) {
      this.setState({
        [e.target.name]: e.target.value
      });
    }
  };

  errorMessage = () => {
    if (this.state.error) {
      return (
        <ErrorMessage>
          Invalid email or password. Please try again.
        </ErrorMessage>
      );
    }
  };

  render() {
    const { loaderVisible } = this.state;

    if (loaderVisible) {
      return <Loader />;
    } else {
      return (
        <Background>
          <Shell>
            <form>
              <h2>Sign In</h2>
              <input
                type="email"
                onChange={this.inputToState}
                name="email"
                placeholder="EMAIL"
              />
              <input
                type="password"
                onChange={this.inputToState}
                name="password"
                placeholder="PASSWORD"
              />
              {this.errorMessage()}
              <Submit onSubmit={this.loginUser} onClick={this.loginUser}>
                Sign In
              </Submit>
              <Link
                style={{ marginTop: "20px", color: "#969696" }}
                to="/signup"
              >
                No account? Sign up here
              </Link>
            </form>
          </Shell>
        </Background>
      );
    }
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ goToInterview: () => push("/app/dashboard") }, dispatch);

const LogInUser = gql`
  mutation signInUser($email: String!, $password: String!) {
    signInUser(email: $email, password: $password)
  }
`;

export default flow(
  connect(null, mapDispatchToProps),
  graphql(LogInUser, {
    props: ({ mutate }) => ({
      logIn: (email, password) => mutate({ variables: { email, password } })
    })
  })
)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/signIn/index.js